import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, MapPin } from "lucide-react";
import { rp } from "@/lib/format";
import { ConditionBadge } from "@/components/ConditionBadge";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export function ProductCard({ p }) {
  const { addToCart, t } = useApp();
  const navigate = useNavigate();
  const img = (p.photos || [])[0];
  const discount = p.original_price && p.original_price > p.price
    ? Math.round((1 - p.price / p.original_price) * 100) : null;

  return (
    <div data-testid={`product-card-${p.id}`}
      className="group bg-white rounded-xl border border-rl-border overflow-hidden shadow-sm hover:shadow-lg hover:border-rl-primary transition-all duration-300 hover:-translate-y-1 flex flex-col">
      <Link to={`/produk/${p.id}`} className="relative block aspect-square overflow-hidden bg-rl-bg2">
        {img ? (
          <img src={img} alt={p.title} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : <div className="w-full h-full grid place-items-center text-rl-muted">No image</div>}
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          <ConditionBadge condition={p.condition} />
          {p.negotiable && <span className="rounded-full bg-white/90 text-rl-secondary border border-rl-border px-2 py-0.5 text-[10px] font-semibold">{t("negotiable")}</span>}
        </div>
        {discount && <span className="absolute top-2 right-2 rounded-md bg-rl-primary text-white px-1.5 py-0.5 text-[11px] font-bold">-{discount}%</span>}
      </Link>
      <div className="p-3 sm:p-4 flex flex-col gap-1 flex-1">
        {p.brand && <span className="text-[11px] uppercase tracking-wider font-semibold text-rl-muted">{p.brand}</span>}
        <Link to={`/produk/${p.id}`} className="font-semibold text-rl-ink text-sm line-clamp-2 leading-snug hover:text-rl-primary">{p.title}</Link>
        <div className="mt-1">
          <span className="text-rl-ink font-bold text-base">{rp(p.price)}</span>
          {p.original_price && <span className="ml-2 text-xs text-rl-muted line-through">{rp(p.original_price)}</span>}
        </div>
        {p.store && (
          <div className="mt-1 flex items-center gap-1 text-[11px] text-rl-muted">
            {p.store.verified && <ShieldCheck className="w-3 h-3 text-rl-secondary" />}
            <span className="truncate">{p.store.name}</span>
            {p.store.location && <><MapPin className="w-3 h-3 ml-auto" />{p.store.location}</>}
          </div>
        )}
        <div className="mt-2 grid grid-cols-2 gap-2">
          <button data-testid={`buy-now-${p.id}`} onClick={() => { addToCart(p); navigate("/checkout"); }}
            className="rounded-lg bg-rl-primary hover:bg-rl-primaryHover text-white text-xs font-semibold py-2 transition-colors">
            {t("buy_now")}
          </button>
          <button data-testid={`add-cart-${p.id}`} onClick={() => { addToCart(p); toast.success("Ditambahkan ke keranjang"); }}
            className="rounded-lg border border-rl-border hover:border-rl-primary text-rl-ink text-xs font-semibold py-2 transition-colors">
            {t("add_cart")}
          </button>
        </div>
      </div>
    </div>
  );
}
